"use client";

import PhoneInput from "react-phone-input-2";
import useTNStore from "@/stores/TNStore";
import "react-phone-input-2/lib/material.css";
import _ from "lodash";
import { usePathname, useRouter } from "next/navigation";

export default function MyTN() {
    const { tn, setTN } = useTNStore();
    const pathname: string = usePathname();
    const router = useRouter();

    /**
     * Refresh the page to update the TN if pathname includes any of these paths: call, voice, audit
     */
    function refresh() {
        if (_.includes(pathname, "call-history")) {
            router.replace("/call-history");
        } else if (_.includes(pathname, "voice-settings")) {
            router.replace("/voice-settings");
        } else if (_.includes(pathname, "audit-logs")) {
            router.replace("/audit-logs");
        } else if (_.includes(pathname, "schedules")) {
            router.replace("/schedules");
        } else if (_.includes(pathname, "business-attendant")) {
            router.replace("/business-attendant");
        } else if (_.includes(pathname, "/extensions")) {
            router.replace("/extensions");
        }
    }

    return (
        <PhoneInput
            country={"us"}
            onlyCountries={["us"]}
            value={tn}
            onChange={(phone) => {
                if (phone.length === 11) {
                    // TODO: Change if we go International
                    setTN(phone);
                }
            }}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    refresh();
                }
            }}
            data-testid="my-tn"
            inputProps={{ "data-testid": "my-tn" }}
            placeholder={"+_ (___) ___-____"}
            containerClass="!w-[250px]"
            specialLabel=""
            inputClass="!h-11 !w-[250px] !rounded-[32px] !border-none !bg-att-light-blue"
        />
    );
}
